var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eyesM",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M563.98,305.97c-4.43-4.73-7.97-8.65-11.65-12.42-15.39-15.8-33.82-19.22-53.97-11.72-13.36,4.97-26.1,11.57-39.14,17.4-6.95,3.11-13.8,6.55-21.79,6.09-7.91-.46-15.39-8.7-14.64-16.61.12-1.27,1.58-2.42,2.41-3.63,1.1,1.01,3.01,1.91,3.16,3.04.57,4.32,2.28,3.75,5.34,2.16,15.61-8.13,31.01-16.76,47.07-23.88,16.56-7.34,34.15-8.7,51.5-2.47,16.59,5.96,25.61,19.32,31.76,35.02.41,1.05.38,2.29.42,3.44.03.77-.19,1.55-.48,3.58h.01Z",
    className: "main-eye-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.41,304.4c.48-9.98,5.13-18.3,11.6-25.57,19.37-21.78,43.56-22.63,68.46-13.17,16.5,6.27,31.82,15.64,47.66,23.64,1.61.81,3.17,1.73,5.32,2.91.71-1.85,1.06-3.46,1.9-4.75.69-1.06,1.97-1.73,2.99-2.58.69,1.15,1.9,2.26,1.98,3.45.79,11.73-10.43,20.44-22.52,16.18-12.47-4.39-24.35-10.5-36.39-16.08-9.98-4.63-20.07-9.1-31.13-9.96-13.36-1.04-25.29,3.08-35.12,12.36-3.74,3.52-7.06,7.5-10.41,11.41-.93,1.09-1.3,2.66-1.92,4.02-.8-.61-1.61-1.23-2.41-1.84v-.02Z",
    className: "main-eye-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesM);
export default __webpack_public_path__ + "static/media/eyesM.4ce69d884c54d850168969fb1e1d0001.svg";
export { ForwardRef as ReactComponent };